export function redirectToErrorPage(code = 500): void {
  window.location.assign(`/assets/error.html?code=${code}`);
}
